import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Photos = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="photos icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34.0877 7.68005V8.72309H8.88384H5.52384C4.73184 8.72309 4.08384 9.51461 4.08384 10.4823V14.1605V35.2066V35.9928H2.88C1.296 35.9928 0 34.6964 0 33.1128L0 7.68005C0 6.09605 1.296 4.80005 2.88 4.80005H31.2077C32.7922 4.80005 34.0877 6.09605 34.0877 7.68005ZM18.2092 24.6667C19.906 24.6667 21.2803 23.2915 21.2803 21.5947C21.2803 19.8974 19.906 18.5222 18.2092 18.5222C16.5134 18.5222 15.1382 19.8974 15.1382 21.5947C15.1382 23.2915 16.5134 24.6667 18.2092 24.6667ZM15.618 35.8909H20.6676H21.6276H28.6802H29.6402H39.1922C39.4567 35.8909 39.5513 35.7123 39.4025 35.4944L30.6799 22.6913C30.5306 22.4734 30.2878 22.4734 30.139 22.6913L25.4244 29.6129C25.2761 29.8309 25.0332 29.8309 24.8844 29.6129L22.4186 25.9942C22.2703 25.7763 22.027 25.7763 21.8786 25.9942L15.4082 35.4944C15.259 35.7123 15.3535 35.8909 15.618 35.8909ZM10.7167 38.9633H44.0815V15.4505H10.7167V38.9633ZM45.0415 11.6101H9.75668C8.17316 11.6101 6.87668 12.9065 6.87668 14.4901V39.9233C6.87668 41.5069 8.17316 42.8033 9.75668 42.8033H45.0415C46.626 42.8033 47.9215 41.5069 47.9215 39.9233V14.4901C47.9215 12.9065 46.626 11.6101 45.0415 11.6101Z"
    />
  </svg>
)
